import { getPriceCalendarV3 } from "../../shared/prices-api";

import {
	GET_PRICE_CALENDAR_REQUEST,
	GET_PRICE_CALENDAR_SUCCESS,
	GET_PRICE_CALENDAR_ERROR,
	SET_PRICE_CALENDAR_GO_INTENT,
	SET_PRICE_CALENDAR_BACK_INTENT,
	TOGGLE_PRICE_CALENDAR_MINIMAP,
	TOGGLE_PRICE_CALENDAR_TRIP_TYPE,
	PRICE_CALENDAR_MIN_SEARCH_INTENTS_LENGTH,
	PRICE_CALENDAR_RESET
} from "./constants";

export const getPriceCalendarRequest = (from, to) => ({
	type: GET_PRICE_CALENDAR_REQUEST,
	from,
	to
});

export const getPriceCalendarSuccess = (searchIntents, tripType, goIntent) => ({
	type: GET_PRICE_CALENDAR_SUCCESS,
	tripType,
	searchIntents,
	goIntent
});

export const getPriceCalendarError = error => ({
	type: GET_PRICE_CALENDAR_ERROR,
	error
});

export const setBackIntent = backIntent => ({
	type: SET_PRICE_CALENDAR_BACK_INTENT,
	backIntent
});

export const setGoIntent = goIntent => ({
	type: SET_PRICE_CALENDAR_GO_INTENT,
	goIntent
});

export const toggleMinimap = show => ({
	type: TOGGLE_PRICE_CALENDAR_MINIMAP,
	show
});

export const toggleTripType = tripType => ({
	type: TOGGLE_PRICE_CALENDAR_TRIP_TYPE,
	tripType
});

export const reset = () => ({
	type: PRICE_CALENDAR_RESET
});

export const getPriceCalendarActionCreators = dispatch => {
	const getPriceCalendar = ({ origin, destination, tripType = "OW", goIntent }, query) => {
		dispatch(getPriceCalendarRequest(origin, destination));

		const reqOptions = {
			from: origin.iata,
			to: destination.iata,
			tripType,
			...query
		};

		if (!origin)
			return dispatch(
				getPriceCalendarError("Defina a cidade de origem para ver os preços dos voos")
			);
		goIntent ? (reqOptions.outbound = goIntent) : null;

		getPriceCalendarV3(reqOptions)
			.then(response => {
				let intents = response.data.slice(0, 300);
				if (tripType === "OW" && intents.length < PRICE_CALENDAR_MIN_SEARCH_INTENTS_LENGTH)
					throw "Baixo número de resultados. Selecione outra cidade.";
				dispatch(getPriceCalendarSuccess(intents, tripType, goIntent));
			})
			.catch(err => {
				const str =
					err ||
					"Houve um erro no carregamento dos dados. Escolha a cidade novamente ou atualize a página.";
				dispatch(getPriceCalendarError(str));
			});
	};

	return {
		getPriceCalendar,

		toggleTripType: tripType => dispatch(toggleTripType(tripType)),

		setGoIntent: backIntent => dispatch(setGoIntent(backIntent)),

		setBackIntent: backIntent => dispatch(setBackIntent(backIntent)),

		toggleMinimap: show => dispatch(toggleMinimap(show)),

		reset: () => dispatch(reset())
	};
};
